import MainNavigation from "./navigation/MainNavigation"
import "./App.scss"
import * as sharedComponenets from "./shared/components"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch, RootState } from "./shared/store"
import { useEffect, useState } from "react"
import { TokenEnum, UserSettings } from "./shared/constants/user_constants"
import { login } from "./features/auth/auth-slice"
import { INavbarPage } from "./shared/models/navbar_models"
import { CssBaseline, ThemeProvider } from "@mui/material"
import * as themes from "./shared/themes"
import { useLocalStorageWatcher } from "./shared/components/localStorageWatcher"
import { fetchAppFeatureConfigs } from "./shared/app-slice"

function App() {

  const authSlice = useSelector((state:RootState) => state.auth)
  const appSlice = useSelector((state:RootState) => state.app)

  const dispatch: AppDispatch = useDispatch();
  const [initialLoading, setInitialLoading] = useState(true)
  const [isDarkMode, setIsDarkMode] = useState(true)

  useEffect(() => {
    const idToken = localStorage.getItem(TokenEnum.ID_TOKEN)
    if (idToken){
        dispatch(login(idToken))
    }
    else if(process.env.REACT_APP_AUTH_REQUIRED === 'false'){
      dispatch(login(null, true))
    }

    if(!appSlice.appFeatureConfigs)
      dispatch(fetchAppFeatureConfigs())

    setInitialLoading(false)

    const currentTheme = localStorage.getItem(UserSettings.DARKMODE)
    if (currentTheme)
      setIsDarkMode(currentTheme === 'true')
  }, [])

  // Watches for changes on local storage for darkmode
  useLocalStorageWatcher(UserSettings.DARKMODE, (newValue) => {
    setIsDarkMode(newValue === 'true')
  });

  return (
    <ThemeProvider theme={isDarkMode ? themes.defaultTheme : themes.lightTheme}>
      <sharedComponenets.CustomGlobalStyles />
      <CssBaseline />
      <div className='app'>
        {!authSlice.loading && !initialLoading?
          <>
            <MainNavigation />
          </>
          :
          <>
            <sharedComponenets.Loader />
          </>
        }
      </div>
    </ThemeProvider>
  )
}

export default App